import { render, staticRenderFns } from "./ModalShortUrl.vue?vue&type=template&id=97b867f6"
import script from "./ModalShortUrl.vue?vue&type=script&lang=ts"
export * from "./ModalShortUrl.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports